import { UI } from '../../modules/UI';
import { App } from '../../modules/App';
import { ValidationRules } from '../../modules/ValidationRules';
import { User } from '../../modules/User';

export const Login = (function () {
  let init = () => {
    UI.blockPage();
    let tmpl = require(`./tmpl/login.hbs`);
    UI.pagewrap(tmpl).then(pageinit);
  };

  let pageinit = () => {
    UI.unblockPage();
    handleFormSwitch();
    handleSignInFormSubmit();
    handleSignUpFormSubmit();
    handleForgotFormSubmit();
  };

  // Private Functions
  let displaySignUpForm = () => {
    let $form = $('#loginForm');
    $form.removeClass('kt-login--forgot');
    $form.removeClass('kt-login--signin');

    $form.addClass('kt-login--signup');
    UI.animation.flipInX($form.find('.kt-login__signup')[0]);
  };

  let displaySignInForm = () => {
    let $form = $('#loginForm');
    $form.removeClass('kt-login--forgot');
    $form.removeClass('kt-login--signup');

    $form.addClass('kt-login--signin');
    UI.animation.flipInX($form.find('.kt-login__signin')[0]);
  };

  let displayForgotForm = () => {
    let $form = $('#loginForm');
    $form.removeClass('kt-login--signin');
    $form.removeClass('kt-login--signup');

    $form.addClass('kt-login--forgot');
    UI.animation.flipInX($form.find('.kt-login__forgot')[0]);
  };

  let handleFormSwitch = () => {
    $('#kt_login_forgot').click(function (e) {
      e.preventDefault();
      displayForgotForm();
    });

    $('#kt_login_forgot_cancel').click(function (e) {
      e.preventDefault();
      displaySignInForm();
    });

    $('#kt_login_signup').click(function (e) {
      e.preventDefault();
      displaySignUpForm();
    });

    $('#kt_login_signup_cancel').click(function (e) {
      e.preventDefault();
      displaySignInForm();
    });
  };

  let handleSignInFormSubmit = function () {
    $('#kt_login_signin_submit').click(function (e) {
      e.preventDefault();
      let btn = $(this);
      let form = $(this).closest('form');

      // Validate
      form.validate({ rules: ValidationRules.login });
      if (!form.valid()) return;

      UI.btn.spinnerRight(btn);

      let formData = form.serializeObject();

      User.signin(formData);
    });
  };

  var handleSignUpFormSubmit = function () {
    $('#kt_login_signup_submit').click(function (e) {
      e.preventDefault();

      let btn = $(this);
      let form = $(this).closest('form');

      form.validate({ rules: ValidationRules.signup });
      if (!form.valid()) return;

      let formData = form.serializeObject();
      btn.addClass('kt-spinner kt-spinner--right kt-spinner--sm kt-spinner--light').attr('disabled', true);

      $.when(App.ajaxData('users/create', formData, 'POST')).done((res) => {
        // similate 2s delay
        setTimeout(function () {
          btn.removeClass('kt-spinner kt-spinner--right kt-spinner--sm kt-spinner--light').attr('disabled', false);
          form.clearForm();
          form.validate().resetForm();

          // display signup form
          displaySignInForm();
          var signInForm = $form.find('.kt-login__signin form');
          signInForm.clearForm();
          signInForm.validate().resetForm();

          showErrorMsg(signInForm, 'success', 'Thank you. To complete your registration please check your email.');
        }, 2000);
      });
    });
  };

  var handleForgotFormSubmit = function () {
    $('#kt_login_forgot_submit').click(function (e) {
      e.preventDefault();

      let btn = $(this);
      let form = $(this).closest('form');

      form.validate({ rules: ValidationRules.passwordForgot });
      if (!form.valid()) return;

      btn.addClass('kt-spinner kt-spinner--right kt-spinner--sm kt-spinner--light').attr('disabled', true);

      form.ajaxSubmit({
        url: '',
        success: function (response, status, xhr, $form) {
          // similate 2s delay
          setTimeout(function () {
            btn.removeClass('kt-spinner kt-spinner--right kt-spinner--sm kt-spinner--light').attr('disabled', false); // remove
            form.clearForm(); // clear form
            form.validate().resetForm(); // reset validation states

            // display signup form
            displaySignInForm();
            var signInForm = $form.find('.kt-login__signin form');
            signInForm.clearForm();
            signInForm.validate().resetForm();

            showErrorMsg(signInForm, 'success', 'Cool! Password recovery instruction has been sent to your email.');
          }, 2000);
        }
      });
    });
  };

  let showErrorMsg = function (form, type, msg) {
    let alert = `<div class="kt-alert kt-alert--outline alert alert-${type} alert-dismissible" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><i class="fal fa-times"></i></button>
                    <span>${msg}</span>
                  </div>`;

    form.find('.alert').remove();
    $(alert).prependTo(form);
    //     Util.animateClass($(alert)[0], 'fadeIn animated');
    UI.animation.fadeIn($(alert)[0]);
  };

  return {
    init
  };
})();
